import { useLinesStore } from "../../stores/useLinesStore";

export function useLine(codigo = null) {

    return  useLinesStore(state => {
        if(!codigo) return null;
        return state.linhasDisponiveisMap.get(codigo);

    });
}